<template>
  <div
    class="introduction-contact"
    v-if="branchAddress !== '' || branchPhone !== ''"
  >
    <h3 v-if="title">{{ title }}</h3>
    <div class="timeShow">
      <label></label>
      <p class="time">工作时间&nbsp;&nbsp;&nbsp;&nbsp;08:00 - 17:30</p>
    </div>
    <div class="telShow" v-if="branchPhone !== ''">
      <label></label>
      <p class="time">
        分公司联系方式<span class="telNum" @click="callPhone(branchPhone)">{{
          branchPhone
        }}</span>
      </p>
    </div>
    <div class="telShow" v-if="companyPhone !== ''">
      <label></label>
      <p class="time">
        企业联系方式<span class="telNum" @click="callPhone(companyPhone)">{{
          companyPhone
        }}</span>
      </p>
    </div>
    <div class="addressShow" v-if="branchAddress !== ''">
      <label></label>
      <p class="address">{{ branchAddress }}</p>
    </div>
  </div>
</template>

<script>
import { getCityConfig } from '../api'
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    cityId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      branchAddress: '',
      branchPhone: '',
      companyPhone: '',
    }
  },

  mounted() {
    this.initContactData()
  },

  methods: {
    callPhone(phoneNumber) {
      window.location.href = 'tel://' + phoneNumber
    },

    initContactData(cityId) {
      if (this.$route.query.companyId) {
        getCityConfig({
          serviceCityId: this.cityId,
          companyId: this.$route.query.companyId,
        }).then((data) => {
          this.branchAddress = data.branchAddress
          this.branchPhone = data.branchPhone
          this.companyPhone = data.companyPhone
          console.log('this.branchPhone', this.branchPhone)
          console.log('this.branchAddress', this.branchAddress)
          console.log('this.companyPhone', this.companyPhone)
        })
      } else {
        getCityConfig({ serviceCityId: this.cityId }).then((data) => {
          this.branchAddress = data.branchAddress
          this.branchPhone = data.branchPhone
          console.log('this.branchPhone', this.branchPhone)
          console.log('this.branchAddress', this.branchAddress)
        })
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl';

.introduction-contact {
  margin-bottom: 20px;
  padding: 40px 60px;
  line-height: 1;
  background-color: #fff;
  color: $ucar_font_color;

  h3 {
    text-align: center;
    margin-bottom: 30px;
    font-size: $ucar_font_h4;
    font-weight: bold;
  }

  .telNum {
    color: #0099FF;
    padding-left: 30px;
    font-size: $ucar_font_h6;
  }

  .address {
    width: 90%;
    line-height: $ucar_font_h6;
    padding-left: 30px;
    font-size: $ucar_font_h6;
  }

  .time {
    width: 90%;
    line-height: $ucar_font_h6;
    padding-left: 30px;
    font-size: $ucar_font_h6;
  }

  .timeShow {
    display: flex;
    flex-direction: row;
    align-items: center;

    label {
      height: 54px;
      width: 54px;
      background-image: url('../assets/workTime.png');
      background-size: 54px 54px;
      display: block;
    }
  }

  .telShow {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;

    label {
      height: 54px;
      width: 54px;
      background-image: url('../assets/tel.png');
      background-size: 54px 54px;
      display: block;
    }
  }

  .addressShow {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;

    label {
      height: 54px;
      width: 54px;
      background-image: url('../assets/address.png');
      background-size: 54px 54px;
      display: block;
    }
  }
}
</style>
